export default "__VITE_PUBLIC_ASSET__3e690ff7__"